<template>
    <default-template>
        <v-container>
            <v-row>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="auto">
                    <v-card width="260" tile flat elevation="0">
                        <v-card color="#366fd7" class="py-30px white--text" elevation="0" flat tile to="/mypage">
                            <v-card-title class="py-0">
                                <span class="tit tit--sm">마이페이지</span>
                            </v-card-title>
                        </v-card>
                        <v-list>
                            <template v-for="item in items">
                                <v-list-group :key="item.title" :value="getIsOpen(item)">
                                    <template #activator>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                                        </v-list-item-content>
                                    </template>
                                    <v-list-item-group>
                                        <template v-for="item in item.items">
                                            <v-list-item dense :to="item.route" :key="item.title">
                                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                                            </v-list-item>
                                        </template>
                                    </v-list-item-group>
                                </v-list-group>
                            </template>
                            <!-- <v-list-item-group mandatory>
                                <v-list-item dense to="/mypage/shop/purchases">
                                    <v-list-item-title>도서 구매내역</v-list-item-title>
                                </v-list-item>
                                <v-list-item dense to="/mypage/shop/ebooks">
                                    <v-list-item-title>eBook 열람</v-list-item-title>
                                </v-list-item>
                                <v-list-item dense to="/mypage/shop/carts">
                                    <v-list-item-title>장바구니</v-list-item-title>
                                </v-list-item>
                                <v-list-item dense to="/mypage/shop/gift-purchases">
                                    <v-list-item-title>도서선물내역 조회</v-list-item-title>
                                </v-list-item>
                                <v-list-item dense to="/mypage/cashes/inquiry">
                                    <v-list-item-title>캐시내역</v-list-item-title>
                                </v-list-item>
                                <v-list-item dense to="/mypage/event">
                                    <v-list-item-title>이벤트 참여내역</v-list-item-title>
                                </v-list-item>
                                <v-list-item dense to="/mypage/cashes/give">
                                    <v-list-item-title>캐시선물하기</v-list-item-title>
                                </v-list-item>
                                <v-list-item dense to="/mypage/cashes/gift">
                                    <v-list-item-title>캐시선물내역</v-list-item-title>
                                </v-list-item>
                                <v-list-item dense to="/mypage/cashes/charge">
                                    <v-list-item-title>캐시충전</v-list-item-title>
                                </v-list-item>
                                <v-list-item dense to="/mypage/gshop/orders">
                                    <v-list-item-title>상품권 구매내역</v-list-item-title>
                                </v-list-item>
                                <v-list-item dense to="/mypage/dshop/orders">
                                    <v-list-item-title>배송상품 구매내역</v-list-item-title>
                                </v-list-item>
                                <v-list-item dense to="/mypage/points">
                                    <v-list-item-title>포인트 내역</v-list-item-title>
                                </v-list-item>
                                <v-list-item dense to="/mypage/profile">
                                    <v-list-item-title>회원정보수정</v-list-item-title>
                                </v-list-item>
                            </v-list-item-group> -->
                        </v-list>
                    </v-card>
                </v-col>
                <v-col>
                    <div class="contents-area">
                        <div class="contents-area__inner">
                            <slot />
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </default-template>
</template>
<script>
import { mapState } from "vuex";
import DefaultTemplate from "../DefaultTemplate.vue";

export default {
    components: {
        DefaultTemplate,
    },
    created() {
        if (this.logoff) this.$router.push(`/login`);
    },

    data: () => ({}),

    computed: {
        ...mapState(["user"]),
        accessToken() {
            return this.$store.state.accessToken;
        },
        logoff() {
            return !this.$store.state.accessToken;
        },
        items() {
            return [
                {
                    title: "나누리캐시",
                    items: [
                        { title: "캐시 충전", route: { path: "/mypage/cashes/charge" } },
                        { title: "캐시 내역", route: { path: "/mypage/cashes/inquiry" } },
                        { title: "캐시 선물하기", route: { path: "/mypage/cashes/give" } },
                        { title: "캐시 선물내역", route: { path: "/mypage/cashes/gift" } },
                    ],
                },
                {
                    title: "보증금",
                    items: [
                        //
                        { title: "보증금 내역", route: { path: "/mypage/deposits" } },
                    ],
                    shows: this.user?.hasDeposit ?? false,
                },
                {
                    title: "상품권 교환소",
                    items: [
                        //
                        { title: "교환 내역", route: { path: "/mypage/exchange" } },
                    ],
                },
                {
                    title: "나누리 상품권",
                    items: [
                        //
                        { title: "구매 내역", route: { path: "/mypage/nshop/orders" } },
                    ],
                },
                {
                    title: "도서",
                    items: [
                        //
                        { title: "도서 내역", route: { path: "/mypage/shop/purchases" } },
                    ],
                },
                {
                    title: "쿠폰",
                    items: [
                        //
                        { title: "구매 내역", route: { path: "/mypage/gshop/orders" } },
                    ],
                },
                {
                    title: "배송상품",
                    items: [
                        //
                        { title: "구매 내역", route: { path: "/mypage/dshop/orders" } },
                    ],
                },
                {
                    title: "나의 정보",
                    items: [
                        { title: "가상계좌", route: { path: "/mypage/vaccount" } },
                        { title: "이벤트 참여내역", route: { path: "/mypage/event" } },
                        { title: "회원정보 수정", route: { path: "/mypage/profile" } },
                    ],
                },
            ].filter((item) => item.shows ?? true);
        },
    },
    methods: {
        getIsOpen({ items }) {
            return items.some(({ route }) => route.path == this.$route.path);
        },
    },
};
</script>
